import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register.vue";
import ForgetPassword from "@/pages/ForgetPassword.vue";
import ResetPassword from "@/pages/ResetPassword.vue";
import SignIn from "@/pages/SignIn.vue";
import AuthPage from "@/pages/AuthPage.vue";
import Onboarding from "@/pages/Onboarding.vue";
import SignInForm from "@/components/auth/SignInForm.vue";
import ChoosePathForm from "@/components/auth/ChoosePathForm.vue";
import SignUpForm from "@/components/auth/SignUpForm.vue";
import ForgetPasswordForm from "@/components/auth/ForgetPasswordForm.vue";
// lazy load
const AccountActivation = () => import("@/pages/ActivateAccount.vue");
const NotFound = () => import("@/pages/404NotFound.vue");
const JoinUs = () => import("@/pages/JoinUs.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/auth/signin",
    meta: { hideLayout: true, title: "" },
  },
  {
    path: "/login",
    redirect: "/auth/signin",
  },
  {
    path: "/auth",
    component: AuthPage,
    children: [
      { path: "signin", component: SignInForm, meta: { title: "Sign In" } },
      {
        path: "choose",
        component: ChoosePathForm,
        meta: { title: "Choose Your Path" },
      },
      {
        path: "signup/:role",
        component: SignUpForm,
        props: true,
        meta: { title: "Sign Up" },
      },
      {
        path: "forgot",
        component: ForgetPasswordForm,
        meta: { title: "Forgot Password" },
      },
    ],
    meta: { hideLayout: true, title: "Authentication" },
  },
  {
    path: "/onboarding/:role",
    component: Onboarding,
    props: true,
    meta: { hideLayout: true, title: "Onboarding" },
  },
  {
    path: "/account/activation/:token?/:selectedLanguage?",
    name: "accountActivation",
    strict: false,
    component: AccountActivation,
    meta: { hideLayout: true, title: "Account Activation" },
  },
  {
    path: "/signup",
    redirect: "/auth/choose",
    meta: { hideLayout: true },
  },
  {
    path: "/joinus",
    name: "joinus",
    component: JoinUs,
    meta: { hideLayout: true },
  },
  {
    path: "/account/forget-password",
    redirect: "/auth/forgot",
    meta: { hideLayout: true, title: "Forget Password" },
  },
  {
    path: "/account/reset-password/:token?",
    name: "reset-password",
    component: ResetPassword,
    meta: { hideLayout: true, title: "Reset Password" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { hideLayout: true, title: "Page Not Found" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  const base = "Tawa Digital";
  document.title = to.meta.title ? `${to.meta.title} - ${base}` : base;
});

//----------------------------------------
// the route guarder
/*router.beforeEach((_to, _from, next) => {
  const isAuthRequired = _to.matched
    .some(({ name }) => name !== 'login' && name !== 'signup' && name !== 'forget-password' && name !== 'reset-password' && name !== 'accountActivation')
  const agencyRoleRequired = _to.matched.some(
    ({ name }) => name === 'discovertalents'
  )
  const _role = token_service.getUser()?.role || 'GUEST';

  const loggedIn = token_service.getUser()

  if (isAuthRequired && !loggedIn) {
    next("/login")
  }
  else {
    // in case user authenticated
    if (agencyRoleRequired) {
      if (_role === "AGENCY") {
        next()
      } else {
        next("/")
      }
    } else {
      next()
    }

  }
})*/

export default router;
